import { render, staticRenderFns } from "./ai-pill.vue?vue&type=template&id=5298db12&scoped=true"
import script from "./ai-pill.vue?vue&type=script&lang=js"
export * from "./ai-pill.vue?vue&type=script&lang=js"
import style0 from "./ai-pill.vue?vue&type=style&index=0&id=5298db12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5298db12",
  null
  
)

export default component.exports